import { createFeatureSelector, createSelector } from '@ngrx/store';
import { OfferState } from './offers.state';

export const getOffersFeatureState = createFeatureSelector('offers');

export const selectOffers = createSelector(
  getOffersFeatureState,
  (state: OfferState) => state.offers
);

export const selectPreviewOffer = createSelector(
  getOffersFeatureState,
  (state: OfferState) => state.previewOffers
);

export const selectAmount = createSelector(
  getOffersFeatureState,
  (state: OfferState) => state.amount
);

export const selectIsLoading = createSelector(
  getOffersFeatureState,
  (state: OfferState) => state.isLoading
);

export const selectDefaultPreviewOffer = createSelector(
  getOffersFeatureState,
  (state: OfferState) => state.previewOffer
);

export const selectOfferQuantity = createSelector(
  getOffersFeatureState,
  (state: OfferState) => state.offerQuantity
);

export const selectSelectedOfferId = createSelector(
  getOffersFeatureState,
  (state: OfferState) => state.offerId
);

export const selectNumberOfInstallments = createSelector(
  getOffersFeatureState,
  (state: OfferState) => state.numberOfInstallments
);
